import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ConditionsPage from './pages/ConditionsPage';
import DiseaseDetail from './pages/DiseaseDetail';
import BlogPage from './pages/BlogPage';
import BlogDetail from './pages/BlogDetail';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  useEffect(() => {
    const testBackend = async () => {
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        const response = await fetch(`${BACKEND_URL}/api/`);
        const data = await response.json();
        console.log('Backend connection successful:', data.message);
      } catch (error) {
        console.error('Backend connection error:', error);
      }
    };
    testBackend();
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <>
                <Header />
                <HomePage />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/conditions" element={<ConditionsPage />} />
            <Route path="/conditions/:diseaseId" element={<DiseaseDetail />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:blogId" element={<BlogDetail />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
